import { Link, NavLink } from 'react-router-dom'
import { BrandMark } from './BrandMark'
import { useLocale } from '../i18n/LocaleContext'
import { LocaleSwitch } from './LocaleSwitch'

export function Header() {
  const { t, localePath } = useLocale()

  return (
    <header className="site-header">
      <div className="header-inner">
        <Link to={localePath('/')} className="brand">
          <BrandMark variant="onLight" size="sm" alt="" />
          <span className="brand-name">{t.siteName}</span>
        </Link>

        <nav className="main-nav" aria-label="Main">
          <NavLink to={localePath('/')} end>
            {t.navHome}
          </NavLink>
          <NavLink to={localePath('/hand-drawn-originals')}>
            {t.navOriginalArtworks}
          </NavLink>
          <NavLink to={localePath('/prints')}>{t.navPrints}</NavLink>
          <NavLink to={localePath('/miniatures')}>{t.navMiniatures}</NavLink>
          <NavLink to={localePath('/files')}>{t.navFiles}</NavLink>
          <NavLink to={localePath('/links')}>{t.navLinks}</NavLink>
        </nav>

        <div className="header-actions">
          <LocaleSwitch />
        </div>
      </div>
    </header>
  )
}
